export function isSelectableWorkspaceMembership(membership) {
    const status = String(membership?.memberShipStatus || "joined");
    return !["removed", "restricted"].includes(status)
        && membership?.workspace?.workspaceStatus !== "archived";
}

export function selectableWorkspaceMemberships(memberships) {
    return (Array.isArray(memberships) ? memberships : [])
        .filter(isSelectableWorkspaceMembership);
}

export function resolveWorkspaceSelection(memberships, currentMembership, serverSelectionRequired = false) {
    const available = selectableWorkspaceMemberships(memberships);
    const currentKey = currentMembership?.documentId || currentMembership?.id;
    const currentAvailable = currentKey
        ? available.some((membership) => String(membership.documentId || membership.id) === String(currentKey))
        : false;
    // Selection is only forced when there is actually a workspace to pick.
    // A user with no selectable workspace (fresh account or all memberships
    // removed/archived) must land on the creation/onboarding flow instead of
    // a chooser dialog with nothing to choose from.
    const needsReplacementSelection = Boolean(currentKey && !currentAvailable);
    const selectionRequired = available.length > 0
        && (Boolean(serverSelectionRequired) || needsReplacementSelection);
    return {
        memberships: available,
        selectionRequired,
        defaultMembership: selectionRequired
            ? null
            : available.find((membership) => membership.isDefault) || available[0] || null,
    };
}
